'use client';

import {createContext, useCallback, useState} from 'react';
import {isMobile} from 'react-device-detect';

/* ******************************************************************
 * Types
 ****************************************************************** */

/* ******************************************************************
 * AppContext
 ****************************************************************** */
type AppContextT = {
  // Properties
  isMobile: boolean;
  isMobileMenuOpen: boolean;

  // Methods
  toggleMobileMenu: () => void;
};

const AppContext = createContext({} as AppContextT);

/* ******************************************************************
 * AppProvider
 ****************************************************************** */
export const AppProvider = ({children}: {children: React.ReactNode}) => {
  // State
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  }, [isMobileMenuOpen]);

  /* ******************************************************************
   * Configuration
   ******************************************************************* */

  return (
    <AppContext.Provider
      value={{
        isMobile,
        isMobileMenuOpen,
        toggleMobileMenu,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export {AppContext};
